// Globals
import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';

// Components
import { StyledBadge } from '../ProductsList/ProductsListStyles';
import ProductOfMonthTableActions from '../ProductOfMonthTableActions/ProductOfMonthTableActions';

// Models
import { IProduct } from '@/models/products.model';
import { ROUTES } from '@/models/router.model';

// Helpers
import { formatDate } from '@/utils';
import { DateFormats } from '@/constants/dates';

type TGetProductsTableColumns = {
  t: TFunction;
  handleEditClick: (product: IProduct) => void;
  setProductForDelete: (product: IProduct) => void;
  canManage: boolean;
};

export const useGetProductsOfMonthTableColumns = ({
  t,
  handleEditClick,
  setProductForDelete,
  canManage,
}: TGetProductsTableColumns): ColumnsType<IProduct> => [
  {
    title: t('products_list_store'),
    dataIndex: 'store',
    key: 'store',
    render: (store) => store?.title ?? '—',
  },
  {
    title: t('products_list_category_title'),
    dataIndex: 'category',
    key: 'category',
    render: (category) => category?.name ?? '—',
  },
  {
    title: t('products_list_sku'),
    dataIndex: 'sku',
    key: 'sku',
    render: (_, record) => (
      <a href={`${ROUTES.PRODUCTS}/${record.id}`} target="_blank" rel="noreferrer">
        {record.sku}
      </a>
    ),
  },
  {
    title: t('imports_list_date'),
    dataIndex: 'date_from',
    key: 'date_from',
    render: (_, record) => (
      <div>
        {formatDate(record.date_from ?? '', DateFormats.EUROPEAN_DEFAULT)}
        {` - `}
        {formatDate(record.date_to ?? '', DateFormats.EUROPEAN_DEFAULT)}
      </div>
    ),
  },
  {
    title: t('products_list_status'),
    dataIndex: 'published',
    key: 'published',
    render: (published) => (
      <StyledBadge $isActive={published}>
        {published ? t('products_list_active') : t('products_list_inactive')}
      </StyledBadge>
    ),
  },
  ...(canManage
    ? [
        {
          title: t('products_list_actions'),
          key: 'actions',
          render: (_: unknown, record: IProduct) => (
            <ProductOfMonthTableActions
              record={record}
              handleEditClick={handleEditClick}
              setForDelete={setProductForDelete}
            />
          ),
        },
      ]
    : []),
];
